import React from 'react';


import './App.css';
import Game from './Components/Game';

function App() {
  return (
    <Game />
  );
}

export default App;
